import { twJoin } from "tailwind-merge";

type CaseTemplatesWrapperProps = {
  children: React.ReactNode;
};

export const MENUBAR_WIDTH_KEY = "--menubar-width";
export const CONTENT_WIDTH_KEY = "--content-width";

export const CALC_MARGIN_LEFT = `calc((100vw - var(${CONTENT_WIDTH_KEY})) / 2)`;
export const CALC_MENUBAR_HALF_WIDTH = `calc(var(${MENUBAR_WIDTH_KEY}) / 2)`;

export const CaseTemplatesWrapper: React.FC<CaseTemplatesWrapperProps> = ({
  children,
}) => {
  return (
    <div
      key="case-templates-wrapper"
      className="relative flex flex-1 overflow-hidden"
      style={
        {
          [MENUBAR_WIDTH_KEY]: "12.5rem",
          [CONTENT_WIDTH_KEY]: "clamp(800px, 100vw, 1020px)",
        } as React.CSSProperties
      }
    >
      <div className="decideScrollbar compensate-scrollbar-gutter flex flex-1 flex-start flex-col gap-x-5 overflow-y-auto bg-gray-50 py-10">
        <div
          className={twJoin(
            "flex w-full min-w-[800px] max-w-[1020px] flex-1 flex-start gap-x-5",
          )}
          style={{
            marginLeft: `max(16px, calc(${CALC_MARGIN_LEFT} - ${CALC_MENUBAR_HALF_WIDTH}))`,
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
